/**
 * @fileoverview AWS S3 integration actions for file uploads and presigned URLs
 * @module AWSActions
 */

import apiClient from "../utils/apiClient";

/**
 * Gets an S3 presigned URL to upload files
 * @function
 * @name getPresignedUrl
 * @memberof module:AWSActions
 * @param {Object} config - Configuration object to get presigned url
 * @param {string} config.property - Property ID
 * @param {Array} config.urls - Array of objects with file extensions
 * @returns {Promise<Object>} Object containing upload method, URL, and fields
 */
export const getPresignedUrl = async (config) => {
  const response = await apiClient.post("/aws_signature_url", config);
  return {
    method: "POST",
    url: response.data[0].url,
    fields: response.data[0].fields,
  };
};
